import { apiClient } from '@/api/axiosClient';
import { expandSequenceRange } from '@/lib/autoGenerate';
import type { AutoGenerateConfig } from '@/types/labelTemplate';
import type { ReserveSequenceResponse } from '@/types/printing';

/** Reserves `count` never-repeating values from this object's server-side counter and expands them
 * into the formatted strings each of the `count` physical labels should carry, in print order. */
export async function reserveSequenceValues(templateId: string, objectId: string, config: AutoGenerateConfig, count: number): Promise<string[]> {
  const { data } = await apiClient.post<ReserveSequenceResponse>(`/label-templates/${templateId}/sequences/${objectId}/reserve`, {
    count,
    startValue: config.startValue,
    increment: config.increment,
  });
  return expandSequenceRange(config, data.rangeStart, count);
}

/** The values a print run WOULD produce, without consuming them — so the preview can show each
 * label's real barcode instead of repeating one sample across every tile. Indicative only: another
 * operator reserving in between shifts the actual values along, which is why printing still calls
 * reserveSequenceValues rather than trusting whatever the preview showed. */
export async function peekSequenceValues(templateId: string, objectId: string, config: AutoGenerateConfig, count: number): Promise<string[]> {
  const { data } = await apiClient.get<ReserveSequenceResponse>(`/label-templates/${templateId}/sequences/${objectId}/peek`, {
    params: { startValue: config.startValue },
  });
  return expandSequenceRange(config, data.rangeStart, count);
}
